import React, { useEffect, useState } from "react";
import { addMatterTask, updateMatterTask } from "api/index";
import styles from "./Casefile.module.scss";
import { Dialog } from "@progress/kendo-react-dialogs";
import { FormComboBox,  FormDate } from "components/Matters/index";
import { CONSTANT } from "CONSTANT/Matter/MatterActivityForm";
import { TextArea } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";
import { filterBy } from "@progress/kendo-data-query";
import { Tile } from "components/UIComponents/Tile";
import { toast } from "react-toastify";
import { useActiveFeeEarner } from "services/userService";
import SubmitButton from "components/common/SubmitButton";

const CaseTaskForm = (props) => {
  const [dateState, setDateState] = useState(new Date());
  const [dueDateState, setDueDateState] = useState(() => {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 7);
    return currentDate;
  });
  const [isDueDateChecked, setIsDueDateChecked] = useState(false);
  const [details, setDetails] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [comboBoxState, setComboBoxState] = useState({
    [CONSTANT.COMBOBOX.TYPE]: "",
    [CONSTANT.COMBOBOX.FEE_EARNER]: "",
  });
  const { data: feeEarnerData,loading } = useActiveFeeEarner();
  const [feeEarner, setFeeEarner] = useState([]);

  useEffect(() => {
    if (feeEarnerData && feeEarnerData.length > 0) {
      setFeeEarner(feeEarnerData);
      if(props.viewTask){
        const selectedFeeEarner = feeEarnerData.find(
          (item) => item.userRef === props?.viewTask?.feeEarnerRef
        );
        if (selectedFeeEarner) {
          handleComboBoxChange(
            { value: selectedFeeEarner },
            CONSTANT.COMBOBOX.FEE_EARNER
          );
        }
      }
    else if (props?.feeEarnerRef) {
        const selectedFeeEarner = feeEarnerData.find(
          (item) => item.userRef === props?.feeEarnerRef
        );
        if (selectedFeeEarner) {
          handleComboBoxChange(
            { value: selectedFeeEarner },
            CONSTANT.COMBOBOX.FEE_EARNER
          );
        }
      }
    }
  }, [feeEarnerData?.length, props?.feeEarnerRef]);

  useEffect(() => {
    if (props.isView) {
      getEditData();
    }
  }, [props.isView]);

  
  const filterFeeEarner = (filter) => {
    const data = feeEarnerData?.slice() || [];
    return filterBy(data, filter);
  };
  const feeEarnerfilterChange = (event) => {
    setFeeEarner(filterFeeEarner(event.filter));
  };

  const handleComboBoxChange = (e, label) =>
    setComboBoxState((prevState) => ({
      ...prevState,
      [label]: e.value,
    }));

  const handleDateChange = (e) => setDateState(e.value);

  const handleDueDateChange = (e) => setDueDateState(e.value);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    const parseDate = (newDate) => {
      if (!newDate) return null;
      var os = newDate?.getTimezoneOffset();
      return (newDate = new Date(newDate.getTime() - os * 60 * 1000));
    };

    const dataObject = {
      date: parseDate(dateState) || null,
      ...(isDueDateChecked && { dateDueBy: parseDate(dueDateState) }),
      feeEarnerRef:
        comboBoxState[CONSTANT.COMBOBOX.FEE_EARNER]?.userRef || null,
      details: details,
      type: "FeeEarnerTask",
    };
    try {
      const res = props.isView
        ? await updateMatterTask(props?.viewTask?.taskId, dataObject)
        : await addMatterTask(props?.matterId, dataObject);

      if (res.status === 200) {
        props?.setIsRefreshed(!props?.isRefreshed);
        props?.setCloseModal();
      }
    } catch (error) {
      toast.error("Unexpected error occurred");
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const getEditData = async () => {
    setDetails(props.viewTask?.details);
    setDateState(new Date(props.viewTask?.date));
    setIsDueDateChecked(props.viewTask?.dateDueBy ? true : false);
    props.viewTask?.dateDueBy &&
      setDueDateState(new Date(props.viewTask?.dateDueBy));
  };

  const handleCheckboxChange = (e) => {
    setIsDueDateChecked(e.value);
  };

  return (
    <div>
      <Dialog
        title={props.isView ? "Update Task" : "Add Task"}
        onClose={props?.setCloseModal}
      >
        <div
          className="overflow-hidden"
          style={{ width: "45vw", height: "55vh" }}
        >
          <form id="taskForm" onSubmit={handleSubmit}>
            <div className="row">
              <div
                className=" bgForm py-4 px-5 col-5"
                style={{
                  height: "55vh",
                }}
              >
                <div className="d-flex flex-column ">
                  <div className="">
                    <span className={`${styles["add-activity-form-text"]}`}>
                      {props.addFormText}
                    </span>
                  </div>
                  <FormDate
                    isStyled={true}
                    className="col-12 mt-3"
                    label={"Date"}
                    onChangeDate={handleDateChange}
                    state={{ Date: dateState }}
                  />
                  <FormComboBox
                    required={true}
                    isStyled={true}
                    className="col-12 mt-4"
                    //   width={"260px"}
                    wf={true}
                    onChangeComboBox={handleComboBoxChange}
                    onFilterChange={feeEarnerfilterChange}
                    data={feeEarner}
                    textField="display"
                    state={comboBoxState}
                    name={CONSTANT.COMBOBOX.FEE_EARNER}
                    loading={loading}
                  />
                  <FormDate
                    disabled={!isDueDateChecked}
                    isStyled={true}
                    className="col-12 mt-3"
                    label={"Due Date"}
                    onChangeDate={handleDueDateChange}
                    state={{
                      "Due Date": isDueDateChecked ? dueDateState : null,
                    }}
                    checkbox
                    checked={isDueDateChecked}
                    handleCheckboxChange={handleCheckboxChange}
                  />
                </div>
              </div>
              <div className="col-6 ms-auto me-5">
                <Tile
                  heading="Details"
                  className="px-4 pb-3 my-3 overflow-auto"
                  height={"42vh"}
                >
                  <TextArea
                    rows={10}
                    required
                    size="large"
                    placeholder="Enter Details"
                    autoSize={true}
                    value={details}
                    style={{
                      height: "32vh",
                      maxWidth: "420px",
                    }}
                    onChange={(e) => setDetails(e.value)}
                  />
                </Tile>
              </div>
            </div>
          </form>
        </div>

        <div className="dialog-footer">
          <Button
            className="common-btn bgBtnSecondary border-0 me-4"
            onClick={props?.setCloseModal}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <SubmitButton
            className="me-3"
            onClick={() => {
              handleSubmit({ preventDefault: () => {} });
            }}
            isLoading={isSubmitting}
            disabled={isSubmitting}
          >
            {props.isView ? "Update" : "Save"}
          </SubmitButton>
        </div>
      </Dialog>
    </div>
  );
};

export default CaseTaskForm;
